
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("6Rptm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $deaabceff46e4ecd$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $htF2l = parcelRequire("htF2l");
const $deaabceff46e4ecd$var$LoomPanel = ({ props: props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $htF2l.LoomPanel), props);
var $deaabceff46e4ecd$export$2e2bcd8739ae039 = $deaabceff46e4ecd$var$LoomPanel;

});
parcelRegister("htF2l", function(module, exports) {
$parcel$export(module.exports, "LoomPanel", () => $84fb82e1b818b160$export$761622e58ea33251);

var $eJOHy = parcelRequire("eJOHy");

var $dfpYm = parcelRequire("dfpYm");

var $e2B2h = parcelRequire("e2B2h");

var $kHdo2 = parcelRequire("kHdo2");

var $hz2Wc = parcelRequire("hz2Wc");

var $1yZFW = parcelRequire("1yZFW");
const $84fb82e1b818b160$export$761622e58ea33251 = ()=>{
    const { loomTouchpointVariant: loomTouchpointVariant } = (0, $dfpYm.useLoomTouchpointWithProjectType)();
    if (loomTouchpointVariant === (0, $kHdo2.LoomTouchpointVariant).NONE) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e2B2h.default), {
        data: {
            attributes: {
                loomTouchpointVariant: loomTouchpointVariant
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1yZFW.LoomCoUsePanel), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hz2Wc.LoomRecorderLoadingBlanket), null));
};

});
parcelRegister("hz2Wc", function(module, exports) {
$parcel$export(module.exports, "LoomRecorderLoadingBlanket", () => $d43a192eff765ebe$export$333b15e6d765b856);

var $eJOHy = parcelRequire("eJOHy");

var $1jVV7 = parcelRequire("1jVV7");

var $5Lo0w = parcelRequire("5Lo0w");

var $67YQP = parcelRequire("67YQP");

var $dLR8J = parcelRequire("dLR8J");

var $3963y = parcelRequire("3963y");
const $d43a192eff765ebe$export$333b15e6d765b856 = ()=>{
    const [{ isBlanketShown: isBlanketShown, isPolling: isPolling }] = (0, $3963y.useLoomRecorderLoadingBlanket)();
    // the blanket has to be on top of everything. If we use layers.blanket, it will be behind issue view modals.
    return isBlanketShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $67YQP.default), {
        zIndex: (0, $1jVV7.layers).spotlight + 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Lo0w.default), {
        isTinted: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "loom-recorder-loading-blanket",
        hold: isPolling
    }));
};

});

parcelRegister("1yZFW", function(module, exports) {
$parcel$export(module.exports, "LoomCoUsePanel", () => $e2c3129a3c9bd0c2$export$469c500eeadb1acb);

var $eJOHy = parcelRequire("eJOHy");

var $eq3Hf = parcelRequire("eq3Hf");

var $5vQ2T = parcelRequire("5vQ2T");

var $284TU = parcelRequire("284TU");

var $7SaXU = parcelRequire("7SaXU");

var $1IADZ = parcelRequire("1IADZ");

var $5vVYG = parcelRequire("5vVYG");

var $zkKje = parcelRequire("zkKje");

var $bYLrn = parcelRequire("bYLrn");
const $e2c3129a3c9bd0c2$var$LOOM_APP_NAME = 'Loom';
const $e2c3129a3c9bd0c2$var$LOOM_APP_TYPE = 'com.atlassian.jira.issue.loom';
const $e2c3129a3c9bd0c2$var$ReduxConnectedView = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $284TU.connect)((state)=>({
        isInsertLoomLinkOpened: (0, $5vVYG.isInsertLoomLinkOpenedSelector)(state),
        insertLoomLinkClickedCount: (0, $5vVYG.insertLoomLinkClickedCountSelector)(state),
        links: (0, $zkKje.webLinksWithApplicationIdSelector)(state, (0, $zkKje.generateApplicationId)($e2c3129a3c9bd0c2$var$LOOM_APP_NAME, $e2c3129a3c9bd0c2$var$LOOM_APP_TYPE))
    }), (dispatch)=>({
        onInsertLink: (url)=>dispatch((0, $1IADZ.createWebLinkRequest)(url, 'Loom video', '', {
                type: $e2c3129a3c9bd0c2$var$LOOM_APP_TYPE,
                name: $e2c3129a3c9bd0c2$var$LOOM_APP_NAME
            })),
        onDeleteLink: (id)=>dispatch((0, $1IADZ.deleteWebLinkRequest)(id)),
        onShowInsertLoomLinkForm: ()=>dispatch((0, $7SaXU.showInsertLoomLinkForm)()),
        onHideInsertLoomLinkForm: ()=>dispatch((0, $7SaXU.hideInsertLoomLinkForm)())
    })))((0, $bYLrn.LoomCoUseView));
const $e2c3129a3c9bd0c2$export$469c500eeadb1acb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "loom-videos-section-container",
        packageName: "issueViewBase",
        teamName: "bento",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e2c3129a3c9bd0c2$var$ReduxConnectedView, props));

});
parcelRegister("5vVYG", function(module, exports) {
$parcel$export(module.exports, "insertLoomLinkClickedCountSelector", () => $37f57fc463f87d5d$export$d4e1e55c7928c872);
$parcel$export(module.exports, "isInsertLoomLinkOpenedSelector", () => $37f57fc463f87d5d$export$25945e2a4ec61683);

var $ahm5r = parcelRequire("ahm5r");

var $6az7p = parcelRequire("6az7p");
const $37f57fc463f87d5d$var$loomRootSelector = (0, $ahm5r.createSelector)((0, $6az7p.entitiesSelector), (entities)=>entities.loom);
const $37f57fc463f87d5d$export$d4e1e55c7928c872 = (0, $ahm5r.createSelector)($37f57fc463f87d5d$var$loomRootSelector, (loom)=>loom.insertLoomLinkClickedCount);
const $37f57fc463f87d5d$export$25945e2a4ec61683 = (0, $ahm5r.createSelector)($37f57fc463f87d5d$export$d4e1e55c7928c872, (insertLoomLinkClickedCount)=>insertLoomLinkClickedCount > 0);

});

parcelRegister("bYLrn", function(module, exports) {
$parcel$export(module.exports, "LoomCoUseView", () => $089bf7719dc2c9c3$export$f68e18636ec96e0e);
/* eslint-disable jira/integration/test-id-by-folder-structure */ /* eslint-disable jira/choreographer/message-id-by-folder-structure */ 
var $eJOHy = parcelRequire("eJOHy");

var $ivFXR = parcelRequire("ivFXR");

var $etOSX = parcelRequire("etOSX");

var $kk5YU = parcelRequire("kk5YU");

var $78OnL = parcelRequire("78OnL");

var $9pTd3 = parcelRequire("9pTd3");

var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $dNVxC = parcelRequire("dNVxC");

var $8bxUW = parcelRequire("8bxUW");

var $6d9QY = parcelRequire("6d9QY");

var $ikoPM = parcelRequire("ikoPM");

var $4cTDP = parcelRequire("4cTDP");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $6XJko = parcelRequire("6XJko");

var $aoBMs = parcelRequire("aoBMs");

var $fBMCT = parcelRequire("fBMCT");

var $doGzK = parcelRequire("doGzK");

var $9pLKu = parcelRequire("9pLKu");
function $089bf7719dc2c9c3$var$isSmartAndNotFailedToDeleteWebLink(link) {
    return 'smartLinkId' in link && !('deleteFailed' in link);
}
const $089bf7719dc2c9c3$export$f68e18636ec96e0e = ({ isInsertLoomLinkOpened: isInsertLoomLinkOpened, insertLoomLinkClickedCount: insertLoomLinkClickedCount, links: links, onInsertLink: onInsertLink, onDeleteLink: onDeleteLink, onShowInsertLoomLinkForm: onShowInsertLoomLinkForm, onHideInsertLoomLinkForm: onHideInsertLoomLinkForm })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isReducedMotion = (0, $kk5YU.useIsReducedMotion)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const optimisticlyCreateLinkIdRef = (0, $eJOHy.useRef)();
    const [addButtonRef] = (0, $ikoPM.useGlobalRef)((0, $etOSX.QUICK_ADD_ITEMS_ADD_BUTTON_REF_KEY));
    const validLinks = (0, $eJOHy.useMemo)(()=>links.filter((link)=>!('isCreateFailed' in link && link.isCreateFailed)), [
        links
    ]);
    const previousLinks = (0, $6d9QY.usePrevious)(links.filter($089bf7719dc2c9c3$var$isSmartAndNotFailedToDeleteWebLink));
    // This effect shows flags when a new Loom link is inserted (via recording or via adding an existing link)
    (0, $eJOHy.useEffect)(()=>{
        // Filtering out results of failed deletions (the link is deleted optimistically and if that fails it appears again)
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
        const smartLinks = links.filter($089bf7719dc2c9c3$var$isSmartAndNotFailedToDeleteWebLink);
        if (!optimisticlyCreateLinkIdRef.current) {
            // if we're here, we search for a newly created optimistic link
            const optimisticItem = smartLinks.filter((link)=>Object.hasOwnProperty.call(link, 'isCreateFailed'))// there might be other links that the user tried and failed to create before but we only care about the latest one.
            .pop();
            if (optimisticItem && // It's the first time we ever see this link (optimistic)
            !previousLinks?.find((link)=>link.smartLinkId === optimisticItem.smartLinkId)) optimisticlyCreateLinkIdRef.current = optimisticItem.smartLinkId;
            return;
        }
        // if we're here, an optimistic link we in the previous run was sent to the server and came back with a result we want to check
        const createdItem = smartLinks.find((link)=>link.smartLinkId === optimisticlyCreateLinkIdRef.current);
        optimisticlyCreateLinkIdRef.current = undefined;
        if (!createdItem) {
            // if we got here - it is a bug, should never happen
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'showFlagLoomOptimisticLinkLookup',
                    packageName: 'jiraIssueViewBase',
                    teamName: 'bento'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return;
        }
        if ('isCreateFailed' in createdItem && createdItem.isCreateFailed) {
            showFlag({
                id: 'loomInsertLinkFailure',
                type: 'error',
                title: (0, $aoBMs.messages).failureTitleLinkInserted,
                description: formatMessage((0, $aoBMs.messages).failureLinkInserted),
                messageId: 'issue-view-base.content.loom-videos.ui.co-use.show-flag.error.loom-insert-link-failure',
                messageType: 'transactional'
            });
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'loomInsertLink',
                    packageName: 'jiraIssueViewBase',
                    teamName: 'bento'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        } else showFlag({
            id: 'loomInsertLinkSuccess',
            type: 'success',
            title: (0, $aoBMs.messages).successTitleLinkInserted,
            description: formatMessage((0, $aoBMs.messages).successLinkInserted),
            messageId: 'issue-view-base.content.loom-videos.ui.co-use.show-flag.success.loom-insert-link-success',
            messageType: 'transactional',
            actions: [
                {
                    content: (0, $aoBMs.messages).successActionShare,
                    onClick: ()=>{
                        if (typeof navigator !== 'undefined') navigator.clipboard.writeText(createdItem.href);
                    }
                }
            ]
        });
    }, [
        links,
        showFlag,
        formatMessage,
        previousLinks
    ]);
    // when cross flow succeeds, open the recorder
    (0, $dNVxC.useLoomRecorderTriggerListener)((0, $8bxUW.LoomRecorderTriggerEvent).CROSS_FLOW_SUCCESS, {
        entryPointLocation: 'jiraIssueView_quickAdd_crossflow',
        // TODO confirm what we want for these strings
        // intentionally not localized because Loom RecordSDK does not support i18n
        insertButtonText: 'Add video',
        onInsert: onInsertLink
    });
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'button'
    });
    // animate and offset are used to control the LoomVideosList
    const [animate, setAnimate] = (0, $eJOHy.useState)(false);
    const [offset, setOffset] = (0, $eJOHy.useState)(0);
    // handleScroll is passed to the LoomVideosList to update the animate and offset states
    const handleScroll = (0, $eJOHy.useCallback)((e)=>{
        if (e.direction === 'left') (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'loom-video-list-left-icon-button');
        else (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'loom-video-list-right-icon-button');
        setOffset(e.offset);
        if (isReducedMotion) setAnimate(false);
        else setAnimate(e.animate);
    }, [
        analyticsEvent,
        isReducedMotion
    ]);
    const handleLinkInsert = async (url)=>{
        onInsertLink(url);
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'insert-existing-loom-link-button');
        // reset the LoomVideosList to show the newly inserted link
        setOffset(0);
        if (isReducedMotion) setAnimate(false);
        else setAnimate(true);
    };
    const handleCancelLinkInsert = ()=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'cancel-existing-loom-link-button');
        onHideInsertLoomLinkForm();
        (0, $4cTDP.fg)('jfp_a11y_team_issue_view_keyboard_focus_return_fix') && addButtonRef?.focus();
    };
    // only show the section heading if there are links or the insert link form is opened (this behavior is consistent with the existing web links implementation)
    const shouldShowSection = isInsertLoomLinkOpened || links.length > 0;
    const enableVisualRefreshChanges = (0, $6XJko.isVisualRefreshEnabled)();
    if (!shouldShowSection && enableVisualRefreshChanges) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        testId: "issue-view-base.content.loom-videos.ui.co-use.container"
    }, shouldShowSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ivFXR.SectionHeading), {
        "data-testid": "issue-view-base.content.loom-videos.ui.co-use.heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ivFXR.SectionHeadingTitle), null, formatMessage((0, $aoBMs.messages).loomVideosHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ivFXR.SectionHeadingIcons), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fBMCT.default), {
        onShowInsertLoomLinkForm: onShowInsertLoomLinkForm,
        onInsertLink: onInsertLink
    }))), validLinks.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9pLKu.LoomVideosList), {
        links: validLinks,
        animate: animate,
        offset: offset,
        onScroll: handleScroll,
        onDeleteLink: onDeleteLink
    }), isInsertLoomLinkOpened && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $doGzK.LoomVideoInsert), {
        insertLoomLinkClickedCount: insertLoomLinkClickedCount,
        loomLinkCount: validLinks.length,
        onInsert: handleLinkInsert,
        onCancel: handleCancelLinkInsert
    }));
};

});
parcelRegister("aoBMs", function(module, exports) {
$parcel$export(module.exports, "messages", () => $f8732d21b75b171e$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $f8732d21b75b171e$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    loomVideosHeading: {
        "id": "issue-view-base.content.loom-videos.loom-videos-heading",
        "defaultMessage": "Loom videos"
    },
    loomCardErrorHeading: {
        "id": "issue-view-base.content.loom-videos.loom-card-error-heading",
        "defaultMessage": "An error has occurred"
    },
    successTitleLinkInserted: {
        "id": "issue-view-base.content.loom-videos.success-title-link-inserted",
        "defaultMessage": "Your Loom video has been added!"
    },
    successLinkInserted: {
        "id": "issue-view-base.content.loom-videos.success-link-inserted",
        "defaultMessage": "Copy the link to share it with your team."
    },
    successActionShare: {
        "id": "issue-view-base.content.loom-videos.success-action-share",
        "defaultMessage": "Copy link"
    },
    // TODO - finaliaze these messages
    failureTitleLinkInserted: {
        "id": "issue-view-base.content.loom-videos.failure-title-link-inserted.non-final",
        "defaultMessage": "Failed to add your Loom video"
    },
    failureLinkInserted: {
        "id": "issue-view-base.content.loom-videos.failure-link-inserted.non-final",
        "defaultMessage": "Please try again."
    }
});

});

parcelRegister("fBMCT", function(module, exports) {
$parcel$export(module.exports, "default", () => $f1e4e992ab3f1528$export$2e2bcd8739ae039);
/* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $7rjYb = parcelRequire("7rjYb");
var $aLJ1L = parcelRequire("aLJ1L");

var $dcLzM = parcelRequire("dcLzM");

var $lRq8t = parcelRequire("lRq8t");

var $lYpjS = parcelRequire("lYpjS");

var $kHdo2 = parcelRequire("kHdo2");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $9d4Nt = parcelRequire("9d4Nt");

var $5CNQd = parcelRequire("5CNQd");

var $egCKa = parcelRequire("egCKa");
const $f1e4e992ab3f1528$var$LoomActionsMenu = ({ onShowInsertLoomLinkForm: onShowInsertLoomLinkForm, onInsertLink: onInsertLink })=>{
    const [isDropdownMenuOpen, setIsDropdownMenuOpen] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { loomTouchpointVariant: loomTouchpointVariant } = (0, $lYpjS.useLoomTouchpointVariant)();
    const handleOpenChange = (0, $eJOHy.useCallback)(({ isOpen: isOpen })=>{
        setIsDropdownMenuOpen(isOpen);
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'dropdownMenu'
        }), 'add-loom-icon-dropdown-menu', {
            isOpen: isOpen
        });
    }, [
        createAnalyticsEvent
    ]);
    // under cross-flow, we don't allow users to even add existing Looms
    if (loomTouchpointVariant === (0, $kHdo2.LoomTouchpointVariant).CROSSFLOW || loomTouchpointVariant === (0, $kHdo2.LoomTouchpointVariant).NONE) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        testId: "issue-view-base.content.loom-videos.ui.co-use.loom-actions-menu.drop-down-menu",
        defaultOpen: isDropdownMenuOpen,
        onOpenChange: handleOpenChange,
        placement: "bottom-end",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...props,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                    color: "currentColor",
                    ...props,
                    label: formatMessage((0, $5CNQd.messages).label)
                }),
                ref: triggerRef,
                appearance: "subtle",
                spacing: "compact"
            }),
        shouldRenderToParent: true // This is needed to render the dropdown menu in the same container as the trigger instead of in React.Portal (otherwise domRef.current?.closest('[data-loom-insert-target-marker]' is undefined )
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $egCKa.RecordNewLoomItem), {
        onInsertLink: onInsertLink
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9d4Nt.default), {
        onShowInsertLoomLinkForm: onShowInsertLoomLinkForm
    })));
};
var $f1e4e992ab3f1528$export$2e2bcd8739ae039 = $f1e4e992ab3f1528$var$LoomActionsMenu;

});
parcelRegister("9d4Nt", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4779b6b781b7883$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $jYYbf = parcelRequire("jYYbf");

var $iKUFL = parcelRequire("iKUFL");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $6r3Ld = parcelRequire("6r3Ld");
const $f4779b6b781b7883$var$InsertExistingLoomItem = /*#__PURE__*/ (0, $eJOHy.memo)(({ onShowInsertLoomLinkForm: onShowInsertLoomLinkForm })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'dropdownItem'
    });
    const handleShowInsertLoomLinkForm = (0, $eJOHy.useCallback)(()=>{
        onShowInsertLoomLinkForm();
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'add-icon-button-dropdown-insert-existing-loom-video-button');
    }, [
        onShowInsertLoomLinkForm,
        analyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iKUFL))), {
            color: "currentColor",
            label: "",
            spacing: "spacious"
        }),
        onClick: handleShowInsertLoomLinkForm
    }, formatMessage((0, $6r3Ld.default).existingLoomVideo));
});
var $f4779b6b781b7883$export$2e2bcd8739ae039 = $f4779b6b781b7883$var$InsertExistingLoomItem;

});
parcelRegister("6r3Ld", function(module, exports) {
$parcel$export(module.exports, "default", () => $cdac60ffde3547a0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $cdac60ffde3547a0$var$messages = (0, $7qGN1.defineMessages)({
    insertExistingLoom: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.insert-existing-loom-item.insert-existing-loom",
        "defaultMessage": "Insert existing Loom"
    },
    existingLoomVideo: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.insert-existing-loom-item.existing-loom-video",
        "defaultMessage": "Existing Loom video"
    }
});
var $cdac60ffde3547a0$export$2e2bcd8739ae039 = $cdac60ffde3547a0$var$messages;

});


parcelRegister("5CNQd", function(module, exports) {
$parcel$export(module.exports, "messages", () => $edf4c05935aa85af$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $edf4c05935aa85af$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    label: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.label",
        "defaultMessage": "Add a Loom video"
    }
});

});

parcelRegister("egCKa", function(module, exports) {
$parcel$export(module.exports, "RecordNewLoomItem", () => $41ef8e76d792460c$export$ebe73d592a7310ff);

var $eJOHy = parcelRequire("eJOHy");

var $lYpjS = parcelRequire("lYpjS");

var $kHdo2 = parcelRequire("kHdo2");

var $kPWWO = parcelRequire("kPWWO");

var $dmlEu = parcelRequire("dmlEu");
const $41ef8e76d792460c$export$ebe73d592a7310ff = ({ onInsertLink: onInsertLink })=>{
    const { loomTouchpointVariant: loomTouchpointVariant } = (0, $lYpjS.useLoomTouchpointVariant)();
    switch(loomTouchpointVariant){
        case (0, $kHdo2.LoomTouchpointVariant).COUSE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kPWWO.CoUseRecordItem), {
                onInsertLink: onInsertLink
            });
        case (0, $kHdo2.LoomTouchpointVariant).CROSSJOIN:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dmlEu.CrossJoinRecordItem), null);
        default:
            return null;
    }
};

});
parcelRegister("kPWWO", function(module, exports) {
$parcel$export(module.exports, "CoUseRecordItem", () => $623d3436180701a7$export$ba2e8fe50214cb1);
/* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $eJOHy = parcelRequire("eJOHy");

var $jYYbf = parcelRequire("jYYbf");

var $bTWCd = parcelRequire("bTWCd");

var $jdqdp = parcelRequire("jdqdp");

var $2sLVw = parcelRequire("2sLVw");

var $7ep4S = parcelRequire("7ep4S");

var $lRq8t = parcelRequire("lRq8t");

var $k8E9o = parcelRequire("k8E9o");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $bmoS1 = parcelRequire("bmoS1");

var $1LCJW = parcelRequire("1LCJW");

var $u5urA = parcelRequire("u5urA");
const $623d3436180701a7$export$ba2e8fe50214cb1 = /*#__PURE__*/ (0, $eJOHy.memo)(({ onInsertLink: onInsertLink })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'dropdownItem'
    });
    const issueKey = (0, $bmoS1.useIssueKey)();
    const [{ value: issueType }] = (0, $1LCJW.useIssueTypeField)({
        issueKey: issueKey
    });
    const domRef = (0, $eJOHy.useRef)(null);
    const insertTargetMarkerRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        /* Once the user clicks the record button (this component),
     * the menu closes and this component, with all its hooks, unmounts.
     * When recording ends renderOnInsertFallbackWhen will run in order to determine
     * whether it is still possible to insert the link or not.
     * This is determined by whether the issue from which recording has started is still mounted.
     * This effect saves an identifier that the callback can use when it runs.
     */ insertTargetMarkerRef.current = domRef.current?.closest('[data-loom-insert-target-marker]')?.getAttribute('data-loom-insert-target-marker');
        if (!insertTargetMarkerRef.current) (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'loomSdkInsertTargetMarker notFound', {
            touchpoint: 'loomSectionActionsMenuAddButton'
        });
    }, [
        createAnalyticsEvent
    ]);
    const { openLoomRecorder: openLoomRecorder, recorderState: recorderState } = (0, $k8E9o.useJiraLoomRecorderEntryPoint)({
        entryPointLocation: 'jiraIssueView_loomSectionActionsMenuAddButton',
        onInsert: onInsertLink,
        // intentionally not localized because Loom RecordSDK does not support i18n
        insertButtonText: 'Add video',
        renderOnInsertFallbackWhen: ()=>{
            if (typeof document !== 'undefined') return !insertTargetMarkerRef.current || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.querySelector('[data-loom-insert-target-marker]')?.getAttribute('data-loom-insert-target-marker') !== insertTargetMarkerRef.current;
            return false;
        },
        experimentalFeatures: {
            jiraIssueType: issueType?.name
        }
    });
    const recordLoomVideo = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'add-icon-button-dropdown-record-a-video-button');
        openLoomRecorder?.();
    }, [
        analyticsEvent,
        openLoomRecorder
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        key: "loom-section-actions-menu-recording-button",
        ref: domRef,
        elemBefore: recorderState === 'initialising' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
            size: "medium",
            label: formatMessage((0, $u5urA.default).loading),
            testId: "issue-view-base.content.loom-videos.ui.co-use.loom-actions-menu.record-new-loom-item.co-use.recording-button-spinner"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bTWCd))), {
            label: formatMessage((0, $u5urA.default).videoIcon),
            color: "currentColor",
            spacing: "spacious"
        }),
        onClick: recordLoomVideo,
        isDisabled: recorderState === 'initialising'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        alignItems: "center",
        gap: "space.050"
    }, formatMessage((0, $u5urA.default).newLoomVideo), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: "new"
    }, formatMessage((0, $u5urA.default).newLozenge))));
});

});
parcelRegister("u5urA", function(module, exports) {
$parcel$export(module.exports, "default", () => $52fc1b648c4ba047$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $52fc1b648c4ba047$var$messages = (0, $7qGN1.defineMessages)({
    recordANewVideo: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.record-a-new-video",
        "defaultMessage": "Record a video"
    },
    newLoomVideo: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.new-loom-video",
        "defaultMessage": "New Loom video"
    },
    loomVideo: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.loom-video",
        "defaultMessage": "Loom video"
    },
    loading: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.loading",
        "defaultMessage": "Loading"
    },
    videoIcon: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.video-icon",
        "defaultMessage": "Video icon"
    },
    tryLozenge: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.try-lozenge",
        "defaultMessage": "Try"
    },
    addLozenge: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.add-lozenge",
        "defaultMessage": "Add"
    },
    newLozenge: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.new-lozenge",
        "defaultMessage": "New"
    }
});
var $52fc1b648c4ba047$export$2e2bcd8739ae039 = $52fc1b648c4ba047$var$messages;

});


parcelRegister("dmlEu", function(module, exports) {
$parcel$export(module.exports, "CrossJoinRecordItem", () => $3e422f534f5ee59f$export$73968184b843a034);

var $eJOHy = parcelRequire("eJOHy");

var $6fMzv = parcelRequire("6fMzv");

var $k4fBZ = parcelRequire("k4fBZ");

var $lopBx = parcelRequire("lopBx");

var $jYYbf = parcelRequire("jYYbf");

var $bTWCd = parcelRequire("bTWCd");

var $jdqdp = parcelRequire("jdqdp");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $bnpBF = parcelRequire("bnpBF");

var $aAvEW = parcelRequire("aAvEW");

var $c6U64 = parcelRequire("c6U64");

var $kHdo2 = parcelRequire("kHdo2");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $8rGQ0 = parcelRequire("8rGQ0");

var $u5urA = parcelRequire("u5urA");
const $3e422f534f5ee59f$var$CrossJoinRecordItemWithNestedInteractive = ({ dismissAd: dismissAd })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const crossJoinUrl = (0, $aAvEW.useLoomCrossJoinUrl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isSiteAdmin = (0, $8rGQ0.useIsSiteAdmin)();
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), 'add-icon-button-dropdown-record-a-video-cross-join-button', {
            isSiteAdmin: isSiteAdmin
        });
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(crossJoinUrl, '_blank', 'noreferrer');
    }, [
        createAnalyticsEvent,
        isSiteAdmin,
        crossJoinUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bnpBF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        key: "loom-section-actions-menu-cross-join-recording-button",
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bTWCd))), {
            label: formatMessage((0, $u5urA.default).videoIcon),
            color: "currentColor",
            spacing: "spacious"
        }),
        onClick: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "center",
        gap: "space.050",
        xcss: $3e422f534f5ee59f$var$anchorStyles
    }, formatMessage((0, $u5urA.default).loomVideo), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: "new"
    }, formatMessage((0, $u5urA.default).tryLozenge))), (0, $4cTDP.fg)('enghealth-40167-remove-nested-interactive') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        onClick: (e)=>{
            e.stopPropagation();
        },
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
            }
        },
        xcss: $3e422f534f5ee59f$var$pressableStyles,
        tabIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c6U64.default), {
        onDismiss: dismissAd,
        menuLocation: "quick-add"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        onClick: (e)=>{
            e.stopPropagation();
        },
        xcss: $3e422f534f5ee59f$var$pressableStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c6U64.default), {
        onDismiss: dismissAd,
        menuLocation: "quick-add"
    })))));
};
const $3e422f534f5ee59f$export$73968184b843a034 = ()=>{
    const isFedRampInstance = (0, $lopBx.isFedRamp)();
    const { dismissAd: dismissAd, loomTouchpointVariant: loomTouchpointVariant } = (0, $k4fBZ.useLoomTouchpointVariantWithAdControls)((0, $6fMzv.LOOM_QUICK_ADD_AD_CONTROL_DISMISS_KEY));
    return !isFedRampInstance && loomTouchpointVariant === (0, $kHdo2.LoomTouchpointVariant).CROSSJOIN && ((0, $4cTDP.fg)('enghealth-40167-remove-nested-interactive') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        role: "menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3e422f534f5ee59f$var$CrossJoinRecordItemWithNestedInteractive, {
        dismissAd: dismissAd
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3e422f534f5ee59f$var$CrossJoinRecordItemWithNestedInteractive, {
        dismissAd: dismissAd
    }));
};
const $3e422f534f5ee59f$var$pressableStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    padding: 'space.0'
});
const $3e422f534f5ee59f$var$anchorStyles = (0, $1DXK0.xcss)({
    flexGrow: 1
});

});
parcelRegister("c6U64", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b0626a31997d152$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $NByNW = parcelRequire("NByNW");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $c5wvT = parcelRequire("c5wvT");
var $jLzeC = parcelRequire("jLzeC");
var $ckdeJ = parcelRequire("ckdeJ");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $kGj4V = parcelRequire("kGj4V");
var $kRgKj = parcelRequire("kRgKj");
var $dFqXL = parcelRequire("dFqXL");
var $ftN6c = parcelRequire("ftN6c");

var $8rGQ0 = parcelRequire("8rGQ0");

var $afhOp = parcelRequire("afhOp");
const $2b0626a31997d152$var$DATA_PRIVACY_LINK = 'https://www.atlassian.com/legal/privacy-policy';
const $2b0626a31997d152$var$QUICK_MENU_TYPE = 'loom-only';
// AdControlProvider is needed when importing this component to provide the context for the AdControlDropdownMenu
const $2b0626a31997d152$var$AdControls = ({ onDismiss: onDismiss, menuLocation: menuLocation, bannerLocation: bannerLocation })=>{
    const reasonsModalBulletTwoAppify = (0, $4cTDP.fg)('product-terminology-refresh') ? (0, $afhOp.default).reasonsModalBulletTwoAppify : (0, $afhOp.default).reasonsModalBulletTwo;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isSiteAdmin = (0, $8rGQ0.useIsSiteAdmin)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const eventAttributes = {
        bannerLocation: bannerLocation,
        menuLocation: menuLocation,
        isSiteAdmin: isSiteAdmin,
        quickMenuType: menuLocation === 'quick-add' ? $2b0626a31997d152$var$QUICK_MENU_TYPE : undefined
    };
    const buttonClicked = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'button'
    });
    const linkClicked = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'link'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c5wvT.default), {
        itemId: "loom-videos-banner-ad-controls",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                paddingInline: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...props,
                appearance: "subtle",
                spacing: "compact",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NByNW))), {
                    label: formatMessage((0, $afhOp.default).loomAdControlsTrigger),
                    spacing: "spacious"
                }),
                ref: triggerRef,
                onClick: (event)=>{
                    props.onClick?.(event);
                    (0, $kRgKj.fireUIAnalytics)(buttonClicked, 'adControlsButton', eventAttributes);
                }
            }))
    }, (props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jLzeC.default), {
            ...props,
            flagProps: {
                title: formatMessage((0, $afhOp.default).dismissFlagTitle),
                description: formatMessage((0, $afhOp.default).dismissFlagDescription)
            },
            onClick: ()=>{
                (0, $kRgKj.fireUIAnalytics)(buttonClicked, 'notInterestedButton', eventAttributes);
                return onDismiss();
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ckdeJ.default), {
            ...props,
            onClick: ()=>{
                (0, $kRgKj.fireUIAnalytics)(buttonClicked, 'whyAmISeeingThisButton', eventAttributes);
            },
            modalProps: {
                title: formatMessage((0, $afhOp.default).reasonsModalTitle),
                body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
                    sourceName: "whyAmISeeingThis",
                    sourceType: (0, $aa42ce8e355d58fa$export$1171103ea9083ffa)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dFqXL.MountEvent), {
                    onMount: (analyticsEvent)=>{
                        (0, $kRgKj.fireScreenAnalytics)(analyticsEvent, eventAttributes);
                    }
                }), formatMessage((0, $afhOp.default).reasonsModalExplanation, {
                    strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
                            weight: "bold"
                        }, chunks)
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("li", null, formatMessage((0, $afhOp.default).reasonsModalBulletOne)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("li", null, formatMessage(reasonsModalBulletTwoAppify))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                    xcss: $2b0626a31997d152$var$linkStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                    appearance: "link",
                    spacing: "none",
                    href: $2b0626a31997d152$var$DATA_PRIVACY_LINK,
                    target: "_blank",
                    onClick: ()=>{
                        (0, $kRgKj.fireUIAnalytics)(linkClicked, 'dataPrivacyLink');
                    }
                }, formatMessage((0, $afhOp.default).privacyPolicy))))
            }
        }));
    });
};
const $2b0626a31997d152$var$linkStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.150'
});
var $2b0626a31997d152$export$2e2bcd8739ae039 = $2b0626a31997d152$var$AdControls;

});
// SCREENS
const $aa42ce8e355d58fa$export$f636b5b56f1d624a = 'Screen';
const $aa42ce8e355d58fa$export$9d2de6eebf7462b5 = 'Drawer';
const $aa42ce8e355d58fa$export$1171103ea9083ffa = 'Modal';
const $aa42ce8e355d58fa$export$cae2783c9279926 = 'InlineDialog';
const $aa42ce8e355d58fa$export$d1123261ca8831d2 = 'Dropdown';
const $aa42ce8e355d58fa$export$238d30785c4bca84 = 'Banner';
const $aa42ce8e355d58fa$export$a1562d08625f5d7e = 'UI';
const $aa42ce8e355d58fa$export$947dac6c72b26f81 = 'TRACK';
const $aa42ce8e355d58fa$export$f1d537d508d2945a = 'SCREEN';
const $aa42ce8e355d58fa$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("afhOp", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d1d5ecee0df63db$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $9d1d5ecee0df63db$var$messages = (0, $7qGN1.defineMessages)({
    dismissFlagTitle: {
        "id": "loom-utils.ui.ad-controls.dismiss-flag-title",
        "defaultMessage": "Got it, thanks for letting us know"
    },
    dismissFlagDescription: {
        "id": "loom-utils.ui.ad-controls.dismiss-flag-description",
        "defaultMessage": "You won't see this here as often."
    },
    reasonsModalTitle: {
        "id": "loom-utils.ui.ad-controls.reasons-modal-title",
        "defaultMessage": "Why am I seeing this?"
    },
    reasonsModalExplanation: {
        "id": "loom-utils.ui.ad-controls.reasons-modal-explanation",
        "defaultMessage": "We think that <strong>Loom</strong> will improve your team's productivity. The recommendation is based on:"
    },
    reasonsModalBulletOne: {
        "id": "loom-utils.ui.ad-controls.reasons-modal-bullet-one",
        "defaultMessage": "the size of your team"
    },
    reasonsModalBulletTwo: {
        "id": "loom-utils.ui.ad-controls.reasons-modal-bullet-two",
        "defaultMessage": "your existing Atlassian products"
    },
    privacyPolicy: {
        "id": "loom-utils.ui.ad-controls.privacy-policy",
        "defaultMessage": "Learn more about your data privacy with Atlassian"
    },
    loomAdControlsTrigger: {
        "id": "loom-utils.ui.ad-controls.loom-ad-controls-trigger",
        "defaultMessage": "Loom ad controls actions"
    },
    reasonsModalBulletTwoAppify: {
        "id": "loom-utils.ui.ad-controls.reasons-modal-bullet-two-appify",
        "defaultMessage": "your existing Atlassian apps"
    }
});
var $9d1d5ecee0df63db$export$2e2bcd8739ae039 = $9d1d5ecee0df63db$var$messages;

});





parcelRegister("doGzK", function(module, exports) {
$parcel$export(module.exports, "LoomVideoInsert", () => $217600485cd846fb$export$e7101d4f7ce95cf3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $crJFo = parcelRequire("crJFo");

var $48q59 = parcelRequire("48q59");

var $5CSKW = parcelRequire("5CSKW");

var $3L3Os = parcelRequire("3L3Os");
var $fKXve = parcelRequire("fKXve");
var $6svxr = parcelRequire("6svxr");
var $eRpdx = parcelRequire("eRpdx");
var $byJNH = parcelRequire("byJNH");

var $sY9BV = parcelRequire("sY9BV");

var $lRq8t = parcelRequire("lRq8t");

var $6d9QY = parcelRequire("6d9QY");

var $RDpkC = parcelRequire("RDpkC");

var $5aJR8 = parcelRequire("5aJR8");
const $217600485cd846fb$var$InsertFormActions = ({ onCancel: onCancel })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const formState = (0, $byJNH.useFormState)({
        values: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eRpdx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        type: "submit",
        appearance: "primary",
        isDisabled: !(0, $5aJR8.canInsert)(formState?.values.url)
    }, formatMessage((0, $RDpkC.default).insertButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "subtle",
        onClick: onCancel
    }, formatMessage((0, $RDpkC.default).cancelButton))));
};
const $217600485cd846fb$export$e7101d4f7ce95cf3 = ({ insertLoomLinkClickedCount: insertLoomLinkClickedCount, loomLinkCount: loomLinkCount, onInsert: onInsert, onCancel: onCancel })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const resetRef = (0, $eJOHy.useRef)();
    const inputRef = (0, $eJOHy.useRef)(null);
    const prevInsertLoomLinkClickedCount = (0, $6d9QY.usePrevious)(insertLoomLinkClickedCount);
    const prevLoomLinkCount = (0, $6d9QY.usePrevious)(loomLinkCount);
    const focusOnInput = ()=>{
        /**
     * without this, the focus will not work as expected
     * issue persisted when using requestAnimationFrame instead of setTimeout
     * root cause is explained here https://hello.atlassian.net/wiki/spaces/~71202082ed214fcb8a401788d49831b11097a6/pages/4011824991/ED-24389+-+React18+editor+focus+issues
     *  - TLDR: When DropDown PopOver unmounts, useFocusManager forcing document focus.
     */ setTimeout(()=>{
            if (inputRef.current !== null) inputRef.current.focus({
                preventScroll: true
            });
        }, 100);
    // 100ms is a safe value to ensure the input is focused and user shouldn't notice the delay
    };
    (0, $eJOHy.useEffect)(()=>{
        // This will hapeen when user has successfully just inserted a link, we should re-focus on the input to let user insert another link
        if (prevLoomLinkCount !== undefined && loomLinkCount > prevLoomLinkCount) focusOnInput();
    }, [
        loomLinkCount,
        prevLoomLinkCount
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // this will handle the mount case (where prevInsertLoomLinkClickedCount is undefined) as well as the insert clicked again case
        if (insertLoomLinkClickedCount !== prevInsertLoomLinkClickedCount) {
            (0, $crJFo.smoothScrollIntoCenterIfNeeded)(inputRef.current);
            focusOnInput();
        }
    }, [
        insertLoomLinkClickedCount,
        prevInsertLoomLinkClickedCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3L3Os.default), {
        onSubmit: ({ url: url })=>{
            if ((0, $5aJR8.canInsert)(url)) {
                const trimmedUrl = url.trim(); // a url with leadning/trailing spaces is valid but we want to trim it before inserting, otherwise the endpoint will reject it
                onInsert(trimmedUrl);
                // reset the text field after submitting
                resetRef.current?.();
            }
        }
    }, ({ formProps: formProps, reset: reset })=>{
        resetRef.current = reset;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", {
            ...formProps,
            "data-testid": "issue-view-base.content.loom-videos.ui.co-use.loom-video-insert.form",
            className: (0, $hcewu.default)([
                "_18z1t94y _1wpvt94y _ewaut94y _1hcdt94y"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
            name: "url",
            defaultValue: "",
            isRequired: true,
            validate: (value)=>(0, $5aJR8.shouldShowInvalidMessage)(value) ? 'INVALID_URL' : undefined
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
                ref: inputRef,
                ...fieldProps,
                placeholder: formatMessage((0, $RDpkC.default).placeholderText),
                "aria-label": formatMessage((0, $RDpkC.default).placeholderText),
                autoComplete: "off"
            }), error === 'INVALID_URL' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, formatMessage((0, $RDpkC.default).invalidUrlText)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($217600485cd846fb$var$InsertFormActions, {
            onCancel: onCancel
        }));
    });
};
const $217600485cd846fb$var$formStyles = null;

});
parcelRegister("eRpdx", function(module, exports) {
$parcel$export(module.exports, "default", () => $6411efa125c19813$export$2e2bcd8739ae039);
/* form-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $6411efa125c19813$var$formFooterWrapperStyles = null;
const $6411efa125c19813$var$justifyContentStyles = null;
function $6411efa125c19813$export$2e2bcd8739ae039({ align: align = 'end', children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("footer", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bahesu3 _1pfh1ejb",
            align === 'start' && "_1bah1y6m"
        ]),
        children: children
    });
}

});

parcelRegister("byJNH", function(module, exports) {
$parcel$export(module.exports, "useFormState", () => $43f7cff3f66357ce$export$606f11b2eb45ecc6);

var $eJOHy = parcelRequire("eJOHy");

var $3L3Os = parcelRequire("3L3Os");
// Constantized to avoid a new object reference built every call
const $43f7cff3f66357ce$var$defaultSubscriptionConfig = {
    values: true
};
/**
 * Build a simple hash for a given subscription object for use in a `useMemo` dependencies array.
 * This is because `{ values: true } !== { values: true }`, but `'values:true|' === 'values:true|'`
 *
 * @example { values: true, dirty: false } => 'values:true|dirty:false|'
 */ const $43f7cff3f66357ce$var$getSubscriptionHash = (subscriptionConfig)=>{
    let hash = '';
    for(const key in subscriptionConfig)if (subscriptionConfig.hasOwnProperty(key)) hash += `${key}:${subscriptionConfig[key]}|`;
    return hash;
};
const $43f7cff3f66357ce$export$606f11b2eb45ecc6 = (subscriptionConfig = $43f7cff3f66357ce$var$defaultSubscriptionConfig)=>{
    const { subscribe: subscribe } = (0, $eJOHy.useContext)((0, $3L3Os.FormContext));
    const [state, setState] = (0, $eJOHy.useState)();
    /**
	 * A hash for us to shallow compare the subscriptionConfig object to react to shallow changes, but avoid referential changes.
	 * We avoid computing the hash if the subscription config has referential equality altogether.
	 */ const subscriptionConfigHash = (0, $eJOHy.useMemo)(()=>$43f7cff3f66357ce$var$getSubscriptionHash(subscriptionConfig), [
        subscriptionConfig
    ]);
    /**
	 * Return a memoized version of the subscription config to only react to shallow changes, not referential changes.
	 * Eg. calling `useFormState({ values: true })` twice will result in two different objects by reference, but not by shallow comparison.
	 * This will ensure we don't re-subscribe to the form state when the subscription config is the same.
	 */ const config = (0, $eJOHy.useMemo)(()=>subscriptionConfig, // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally controlled with a hash to have an explicit shallow comparison
    [
        subscriptionConfigHash
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const unsubscribe = subscribe((formState)=>{
            setState(formState);
        }, config);
        return ()=>unsubscribe();
    }, [
        subscribe,
        config
    ]);
    return state;
};

});

parcelRegister("RDpkC", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c1b2e915445faa7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $7c1b2e915445faa7$var$messages = (0, $7qGN1.defineMessages)({
    insertButton: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-video-insert.insert-button",
        "defaultMessage": "Insert"
    },
    cancelButton: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-video-insert.cancel-button",
        "defaultMessage": "Cancel"
    },
    placeholderText: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-video-insert.placeholder-text",
        "defaultMessage": "Add a Loom link"
    },
    invalidUrlText: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-video-insert.invalid-url-text",
        "defaultMessage": "Hold on, let's try a valid Loom link instead."
    }
});
var $7c1b2e915445faa7$export$2e2bcd8739ae039 = $7c1b2e915445faa7$var$messages;

});

parcelRegister("5aJR8", function(module, exports) {
$parcel$export(module.exports, "shouldShowInvalidMessage", () => $9730f74bbcb45f1f$export$4b698f3c1d0fae75);
$parcel$export(module.exports, "canInsert", () => $9730f74bbcb45f1f$export$b4d1262a40ad21d4);
/**
 * Determines if the URL is valid based on the standard Loom share URL pattern
 * @param shareUrl
 * @returns boolean
 * @example isUrlValid('https://www.loom.com/share/6d1794b0dd4c4a8495efa20d090c1602') // true
 * @example isUrlValid('https://stage.loom.com/share/Test-Recording-Video-9b7af208f71f45379a9f297bd065397a') // true
 * @example isUrlValid('https://www.youtube.com/watch?v=Hd0JflMdqyM') // false
 */ const $9730f74bbcb45f1f$export$c4ea027afed2fe4a = (shareUrl)=>{
    // strip query string
    try {
        const loomShareUrlPattern = /^\s*http(s)?:\/\/(www\.|stage\.)?(loom.com)\/(embed|share)\/(.+-)?([a-fA-F0-9]{32})(?:\?|$)/;
        const url = new URL(shareUrl);
        url.search = '';
        return loomShareUrlPattern.test(url.toString());
    } catch  {
        return false;
    }
};
const $9730f74bbcb45f1f$export$4b698f3c1d0fae75 = (shareUrl)=>{
    if (shareUrl === '') // we don't want to show an error message when the field is empty. especially when 'reset' is called after submitting, url is set to '' after that
    return false;
    if (shareUrl === undefined) return true;
    return !$9730f74bbcb45f1f$export$c4ea027afed2fe4a(shareUrl);
};
const $9730f74bbcb45f1f$export$b4d1262a40ad21d4 = (url)=>!$9730f74bbcb45f1f$export$4b698f3c1d0fae75(url) && url?.trim() !== '';

});


parcelRegister("9pLKu", function(module, exports) {
$parcel$export(module.exports, "LoomVideosList", () => $baed7bf71782a71b$export$cc3e92fb04a15d0);
/* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $eJOHy = parcelRequire("eJOHy");

var $8TCRV = parcelRequire("8TCRV");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $kRgKj = parcelRequire("kRgKj");

var $bcydu = parcelRequire("bcydu");

var $liMzh = parcelRequire("liMzh");
const $baed7bf71782a71b$export$cc3e92fb04a15d0 = ({ links: links, animate: animate, offset: offset, onScroll: onScroll, onDeleteLink: onDeleteLink })=>{
    const [pendingDeleteId, setPendingDeleteId] = (0, $eJOHy.useState)(null);
    if (links.length === 0) return null;
    const handleDeleteLink = (id)=>{
        setPendingDeleteId(id);
    };
    const handleDeleteConfirm = (_, analyticsEvent)=>{
        if (pendingDeleteId !== null) onDeleteLink(pendingDeleteId);
        setPendingDeleteId(null);
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'loom-video-lists-confirm-modal-delete-video');
    };
    const handleDeleteCancel = (_, analyticsEvent)=>{
        setPendingDeleteId(null);
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'loom-video-lists-confirm-modal-cancel-delete-video');
    };
    // when there is only a single video, make it fill the available
    const videoCards = links.length === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: "issue-view-base.content.loom-videos.ui.co-use.loom-videos-list.single",
        xcss: $baed7bf71782a71b$var$singleCardStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $liMzh.default), {
        link: links[0],
        onDeleteLink: handleDeleteLink
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8TCRV.FilmstripView), {
        onScroll: onScroll,
        animate: animate,
        offset: offset
    }, links.slice().reverse() // we want the leftmost video to be the most recent one
    .map((l)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            key: l.id,
            testId: "issue-view-base.content.loom-videos.ui.co-use.loom-videos-list.multi",
            xcss: $baed7bf71782a71b$var$multiCardStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $liMzh.default), {
            link: l,
            onDeleteLink: handleDeleteLink
        }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, videoCards, pendingDeleteId !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bcydu.default), {
        onConfirm: handleDeleteConfirm,
        onCancel: handleDeleteCancel
    }));
};
const $baed7bf71782a71b$var$singleCardStyles = (0, $1DXK0.xcss)({
    maxWidth: '700px',
    minWidth: '380px',
    aspectRatio: '1.57894736842',
    marginBottom: 'space.100'
});
const $baed7bf71782a71b$var$multiCardStyles = (0, $1DXK0.xcss)({
    width: '380px',
    height: '240px',
    marginBottom: 'space.100'
});

});
parcelRegister("bcydu", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ca855854e1b6eda$export$2e2bcd8739ae039);
/* eslint-disable jira/choreographer/message-id-by-folder-structure */ // ported from jira/src/packages/issue/issue-view-common-views/src/web-link-line-card-group/delete-modal/index.tsx

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $lJKII = parcelRequire("lJKII");

var $4B7rn = parcelRequire("4B7rn");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $lx6v2 = parcelRequire("lx6v2");
const $0ca855854e1b6eda$export$73392e09138fecd6 = ({ onConfirm: onConfirm, onCancel: onCancel })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const headerMessage = formatMessage((0, $lx6v2.messages).headerMessage);
    const contentMessage = formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $lx6v2.messages).contentMessageIssueTermRefresh : (0, $lx6v2.messages).contentMessage);
    const confirmActionText = formatMessage((0, $lx6v2.messages).confirmActionText);
    const cancelActionText = formatMessage((0, $lx6v2.messages).cancelActionText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lJKII.JiraModal), {
        messageId: "issue-view-base.content.loom-videos.ui.co-use.loom-videos-list.delete-modal.modal-dialog",
        messageType: "transactional",
        onClose: onCancel,
        width: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), {
        hasCloseButton: (0, $4cTDP.fg)('issue-view-enghealth-40720-modal-close-button')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), {
        appearance: "danger"
    }, headerMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, contentMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "primary",
        onClick: onConfirm
    }, confirmActionText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "subtle",
        onClick: onCancel
    }, cancelActionText)))));
};
var $0ca855854e1b6eda$export$2e2bcd8739ae039 = $0ca855854e1b6eda$export$73392e09138fecd6;

});
parcelRegister("lx6v2", function(module, exports) {
$parcel$export(module.exports, "messages", () => $23f2db1c263583b2$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $23f2db1c263583b2$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    headerMessage: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.delete-modal.header-message",
        "defaultMessage": "Remove this Loom video link?"
    },
    contentMessage: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.delete-modal.content-message",
        "defaultMessage": "This will unlink the video from the issue."
    },
    confirmActionText: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.delete-modal.confirm-action-text",
        "defaultMessage": "Remove"
    },
    cancelActionText: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.delete-modal.cancel-action-text",
        "defaultMessage": "Cancel"
    },
    contentMessageIssueTermRefresh: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.delete-modal.content-message-issue-term-refresh",
        "defaultMessage": "This will unlink the video."
    }
});

});


parcelRegister("liMzh", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4d19f8f0a745a2c$export$2e2bcd8739ae039);

var $284TU = parcelRequire("284TU");

var $1IADZ = parcelRequire("1IADZ");

var $5Vm5E = parcelRequire("5Vm5E");
var $d4d19f8f0a745a2c$export$2e2bcd8739ae039 = (0, $284TU.connect)(null, (dispatch, { link: { id: linkId } })=>({
        onDeleteWebLinkRetry: ()=>{
            dispatch((0, $1IADZ.deleteWebLinkRequest)(linkId));
        }
    }))((0, $5Vm5E.LoomVideoCard));

});
parcelRegister("5Vm5E", function(module, exports) {
$parcel$export(module.exports, "LoomVideoCard", () => $86f8cbb1a393187f$export$f91bff7396e50278);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/choreographer/message-id-by-folder-structure */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $6zhpo = parcelRequire("6zhpo");

var $d8UFE = parcelRequire("d8UFE");

var $guChT = parcelRequire("guChT");

var $4cFYC = parcelRequire("4cFYC");

var $4cTDP = parcelRequire("4cTDP");

var $hqYEY = parcelRequire("hqYEY");

var $9pTd3 = parcelRequire("9pTd3");

var $jn1Cb = parcelRequire("jn1Cb");
var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $6d9QY = parcelRequire("6d9QY");

var $kRgKj = parcelRequire("kRgKj");

var $1KufS = parcelRequire("1KufS");

var $2xbUm = parcelRequire("2xbUm");
const $86f8cbb1a393187f$var$TWC_SPOTLIGHT_TARGETS = {
    LINKED_VIDEO_PLAYER: 'linked-video-player',
    CONFLUENCE_CREATION_MODAL: 'confluence-creation-modal',
    CONFLUENCE_LINKED_PAGES: 'confluence-linked-pages'
};
const $86f8cbb1a393187f$export$f30594ea7fd7a441 = 'deleteLoomVideoLinkFailed';
const $86f8cbb1a393187f$export$3ba67dfd4f739fe9 = (0, $hqYEY.metrics).interaction({
    key: 'issue-view.loom-videos-card-load'
});
const $86f8cbb1a393187f$export$f91bff7396e50278 = ({ link: link, onDeleteLink: onDeleteLink, onDeleteWebLinkRetry: onDeleteWebLinkRetry })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)(); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { deleteFailed: deleteFailed } = link;
    const prevDeleteFailed = (0, $6d9QY.usePrevious)(deleteFailed);
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $cSXp8.useFlagsService)();
    const [errorStatus, setErrorStatus] = (0, $eJOHy.useState)(undefined);
    const [isCardLoaded, setIsCardLoaded] = (0, $eJOHy.useState)(false);
    const [isDeleteButtonClicked, setDeleteButtonClicked] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        isCardLoaded ? $86f8cbb1a393187f$export$3ba67dfd4f739fe9.stop() : $86f8cbb1a393187f$export$3ba67dfd4f739fe9.start();
    }, [
        isCardLoaded
    ]);
    (0, $eJOHy.useEffect)(()=>{
        errorStatus && (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'loomVideoCardLoad',
                packageName: 'jiraIssueViewBase',
                teamName: 'bento'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        errorStatus
    ]);
    const handleError = ({ status: status })=>{
        setErrorStatus(status);
        setIsCardLoaded(true);
    };
    const handleResolve = ()=>{
        setIsCardLoaded(true);
    };
    const handleDeleteLink = (_, analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'delete-loom-video-card-button');
        onDeleteLink(link.id);
        setDeleteButtonClicked(true);
    };
    const showDeleteErrorFlag = (0, $eJOHy.useCallback)(()=>{
        const flagId = (0, $jn1Cb.toFlagId)($86f8cbb1a393187f$export$f30594ea7fd7a441);
        showFlag({
            messageId: 'issue-view-base.content.loom-videos.ui.co-use.loom-videos-list.loom-video-card.show-flag.warning.delete-error',
            messageType: 'transactional',
            id: flagId,
            title: (0, $2xbUm.messages).deleteErrorHeading,
            description: (0, $2xbUm.messages).errorBody,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d8UFE))), {
                label: formatMessage((0, $2xbUm.messages).iconLabel),
                color: "var(--ds-icon-warning, #E06C00)",
                spacing: "spacious"
            }),
            type: 'warning',
            isAutoDismiss: true,
            actions: [
                {
                    content: (0, $2xbUm.messages).retryAction,
                    onClick: ()=>{
                        dismissFlag(flagId);
                        onDeleteWebLinkRetry();
                    }
                },
                {
                    content: (0, $2xbUm.messages).cancelAction,
                    onClick: ()=>{
                        dismissFlag(flagId);
                    }
                }
            ]
        });
    }, [
        onDeleteWebLinkRetry,
        dismissFlag,
        showFlag,
        formatMessage
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (deleteFailed && deleteFailed !== prevDeleteFailed) {
            showDeleteErrorFlag();
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'loomVideoCardDeletion',
                    packageName: 'jiraIssueViewBase',
                    teamName: 'bento'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        deleteFailed,
        prevDeleteFailed,
        showDeleteErrorFlag
    ]);
    const card = errorStatus === 'errored' || errorStatus === 'unauthorized' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KufS.LoomErrorCard), {
        url: link.href
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4cFYC.Card), {
        url: link.href,
        appearance: "embed",
        platform: "web",
        frameStyle: "show",
        inheritDimensions: true,
        onError: handleError,
        onResolve: handleResolve
    });
    const loomVideoCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_11c82smr _4t3i1osq _kqswh2mm _vtqp1osq _8kgukb7n _wjvokb7n"
        ])
    }, card, isCardLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-show-on-hover": "true",
        className: (0, $hcewu.default)([
            "_kqswstnw _1bsboahv _19pk1b66 _2hwx1b66 _otyr1b66 _18u01b66 _4t3i1ejb _1pbykb7n _154iidpf _1xi2idpf _1e0c1txw _4cvr1h6o _1bahesu3 _tzy4idpf _1itk11xj"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))),
        appearance: "subtle",
        label: formatMessage((0, $2xbUm.messages).removeButtonLabel),
        spacing: "compact",
        onClick: handleDeleteLink,
        onFocus: (e)=>{
            // after we click cancel button in delete confirmation dialog, the focus goes back to this close icon button
            if (!isDeleteButtonClicked) return;
            e.target.blur();
            setDeleteButtonClicked(false);
        }
    })));
    return (0, $4cTDP.fg)('jira-issue-view-twc-spotlight-tour') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: $86f8cbb1a393187f$var$TWC_SPOTLIGHT_TARGETS.LINKED_VIDEO_PLAYER
    }, loomVideoCard) : loomVideoCard;
};
// can't use xcss here since we have to nest CSS for .loader-wrapper
const $86f8cbb1a393187f$var$wrapperStyles = null; // this is a little absolute positioned element on the top-right of the smart card to show an "x" button
const $86f8cbb1a393187f$var$closeWrapperStyles = null;

});
parcelRegister("1KufS", function(module, exports) {
$parcel$export(module.exports, "LoomErrorCard", () => $c6231e19feb6117f$export$fd3b8d345f1c673);
/* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $eJOHy = parcelRequire("eJOHy");

var $ivFXR = parcelRequire("ivFXR");

var $80DPg = parcelRequire("80DPg");

var $25YjY = parcelRequire("25YjY");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $2l8bu = parcelRequire("2l8bu");

var $lRq8t = parcelRequire("lRq8t");

var $aoBMs = parcelRequire("aoBMs");
const $c6231e19feb6117f$export$fd3b8d345f1c673 = ({ url: url })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2l8bu.ExpandedFrame), {
        allowScrollBar: true,
        setOverflow: true,
        frameStyle: "show",
        href: url,
        inheritDimensions: true,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($25YjY))), {
            label: "Unlink",
            color: "var(--ds-icon, #292A2E)"
        }),
        testId: "issue-view-base.content.loom-videos.ui.co-use.loom-videos-list.loom-video-card.loom-error-card.error-view",
        text: url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $c6231e19feb6117f$var$contentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
        label: "Error",
        color: "var(--ds-icon, #292A2E)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ivFXR.SectionHeadingTitle), null, formatMessage((0, $aoBMs.messages).loomCardErrorHeading))));
};
const $c6231e19feb6117f$var$contentStyles = (0, $1DXK0.xcss)({
    textAlign: 'center',
    alignContent: 'center',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    height: '100%'
});

});

parcelRegister("2xbUm", function(module, exports) {
$parcel$export(module.exports, "messages", () => $2a24f1ae99bbab08$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $2a24f1ae99bbab08$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    removeButtonLabel: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.loom-video-card.remove-button-label",
        "defaultMessage": "Remove linked Loom"
    },
    deleteErrorHeading: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.loom-video-card.delete-error-heading",
        "defaultMessage": "Loom video not removed"
    },
    errorBody: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.loom-video-card.error-body",
        "defaultMessage": "Wait a few moments, then give it another try."
    },
    iconLabel: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.loom-video-card.icon-label",
        "defaultMessage": "warning"
    },
    retryAction: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.loom-video-card.retry-action",
        "defaultMessage": "Try again"
    },
    cancelAction: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.loom-video-card.cancel-action",
        "defaultMessage": "Cancel"
    }
});

});









//# sourceMappingURL=async-loom-videos-panel.dcb1e565.js.map
